import catchify from 'catchify';
import { DEAL_STAGE } from '~/constants/deal-stages';
import { DEFAULT_HIGHER_TIER_EXPERIMENT_NAME } from '~/constants/global';
import { getDefaultPlan } from '~/util/global';

// eslint-disable-next-line import/prefer-default-export
export async function getPdpData(context) {
  const {
    $cachios, route, store,
  } = context;

  const { dealSlug } = route.params;

  // JIC, should already be redirected by redirect middleware
  if (!dealSlug) {
    return context.redirect('/');
  }

  const {
    avatar,
    date_joined: dateJoined,
    deals_purchased: dealsPurchased,
    email_verified: isEmailVerified,
    email,
    has_briefcase: hasBriefcase,
    has_plus: hasPlus,
    id,
    is_staff: isStaff,
    is_betaling: isBetaling,
    username,
  } = store.state.session?.user || {}; // user's value can be null

  // Get the query params to force render, and send them with the request
  const forcePdp = route.querypdp_nuxt;
  const queries = [];
  if (['True', 'False'].includes(forcePdp)) {
    queries.push(`pdp_nuxt=${forcePdp}`);
  }

  // staff, betaling, authenticated, plus, briefcase
  // These are used purely to create unique CDN cache and ignored by the backend
  if (username) {
    queries.push('a=t');

    if (isStaff) {
      queries.push('st=t');
    }

    if (isBetaling) {
      queries.push('bl=t');
    }

    if (hasPlus) {
      queries.push('pl=t');
    }

    if (hasBriefcase) {
      queries.push('bc=t');
    }
  }

  // Important to note!
  // Any changes the possible variations of the query params
  // should be reflected in appsumo/utils/utils.py::generate_cachios_pdp_hash_variations
  // so that the cache is cleared when a deal is updated

  // eslint-disable-next-line prefer-const
  let [err, response] = await catchify($cachios.get(`/api/v2/deals/${dealSlug}/details/${queries.length ? '?' : ''}${queries.join('&')}`, {
    cdn: true,
  }));

  const { deal } = response?.data || {};

  if (err || !deal) {
    return null;
  }

  if (deal.plans?.length > 1) {
    await store.dispatch('experiments/enrollByName', DEFAULT_HIGHER_TIER_EXPERIMENT_NAME);
  }

  store.dispatch(
    'selectedPlan/updatePlan',
    { selectedPlan: getDefaultPlan(deal.plans, store) },
  );

  // jl: let's set this field directly on the deal object to prevent unnecessary prop drilling
  const stageDetails = deal.stage_details;
  stageDetails.is_inactive_indefinitely = stageDetails.current_stage === DEAL_STAGE.INACTIVE
                              && stageDetails.next_stage === null;

  if (deal.banner_details) {
    // jl: prevents prop drilling to DealBannerContent
    deal.banner_details.endDate = deal.dates.end_date;
  }

  const { story } = deal?.products[0] || {};

  return {
    deal,
    story,
    user: {
      avatar,
      dateJoined,
      dealsPurchased,
      email,
      hasBriefcase,
      hasPlus,
      id,
      isEmailVerified,
      isStaff,
      username,
      isAuthenticated: !!id, // Might not be needed, "if user object" might be enough
    },
  };
}
